import { NavLink } from "react-router-dom";
import { useState } from "react";
import "./Navbar.css";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <header className="navbar">
      <div className="nav-inner">
        {/* Brand */}
        <NavLink to="/" className="brand" onClick={() => setMenuOpen(false)}>
          <img src="/images/logo.jpg" alt="Muhammed Tours Logo" className="logo" />
          <span>Muhammed Tours & Safaris</span>
        </NavLink>

        {/* Hamburger */}
        <button
          className="mobile-menu"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </button>

        {/* Navigation Links */}
        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          <NavLink to="/" end onClick={() => setMenuOpen(false)}>HOME</NavLink>
          <NavLink to="/day-tours" onClick={() => setMenuOpen(false)}>DAY TOURS</NavLink>
          <NavLink to="/water-activities" onClick={() => setMenuOpen(false)}>WATER & LAND ACTIVITIES</NavLink>
          
          {/* Dropdown */}
          <div className={`dropdown ${dropdownOpen ? "open" : ""}`}>
            <span
              className="dropdown-label"
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              PACKAGES ▾
            </span>
            <div className="dropdown-menu">
              <NavLink to="/packages/zanzibar" onClick={() => setMenuOpen(false)}>ZANZIBAR BEACH PACKAGES</NavLink>
              <NavLink to="/packages/kilimanjaro" onClick={() => setMenuOpen(false)}>MT. KILIMANJARO PACKAGES</NavLink>
              <NavLink to="/packages/safari" onClick={() => setMenuOpen(false)}>TANZANIA SAFARI PACKAGES</NavLink>
            </div>
          </div>

          <NavLink to="/transfers" onClick={() => setMenuOpen(false)}>TRANSFERS</NavLink>
          <NavLink to="/car-rentals" onClick={() => setMenuOpen(false)}>CAR RENTALS</NavLink>
          <NavLink to="/contact" onClick={() => setMenuOpen(false)}>CONTACT</NavLink>
          <NavLink to="/about" onClick={() => setMenuOpen(false)}>ABOUT US</NavLink>
        </nav>
      </div>
    </header>
  );
}
